import { onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import Loading from '../../components/Loading/Loading';
import { auth } from '../../lib/firebase';

const ProtectedRoutes = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setIsLoading(false);
    });

    return unsubscribe;
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  // Allow access if user exists AND either:
  // 1. Email is verified (email/password users)
  // 2. User signed in with Google (emailVerified is auto-true for OAuth providers)
  const isAuthenticated =
    user &&
    (user.emailVerified ||
      user.providerData.some(
        (provider) => provider.providerId === 'google.com',
      ));

  // Guests go to the login page. This must never point at a route inside
  // ProtectedRoutes, or it redirects to itself forever.
  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default ProtectedRoutes;